/**
 * Csv Schema of ResponsavelAssociado
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {ResponsavelAssociado} from '@/model/resource/ResponsavelAssociado'

/* TODO: review generated schema */
export class CsvResponsavelAssociadoSchema extends Schema {
  readonly name = 'CsvResponsavelAssociado'

  readonly fieldSet: FieldSet<ResponsavelAssociado> = {
    idAssociadoPk: schema => schema.model.idAssociadoPk,
    responsavel: schema => schema.model.responsavel?.$id ?? null,
    razaoSocial: schema => schema.model.razaoSocial,
    nomeFantasia: schema => schema.model.nomeFantasia,
    cnpj: schema => Helper.cnpj(schema.model.cnpj),
    ativo: schema => Helper.bool(schema.model.ativo),
  }
}
